var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import containerHostStyles from '@cof/fs-container-core/lib/container.host.lit.min.js';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * `FsContainer` implements the Financial Services implementation of the Container component.
 * Be sure to consult with the design guidelines for the Container component to ensure proper state usage, it is
 * possible to force the Container component into an unsupported state.
 *
 * ## Installation
 * ### Install the node module:
 * ```bash
 * npm i @cof/fs-container-wc
 * ```
 *
 * ## Usage
 * To import the side-effectful registration of `<fs-container>` call
 *
 * ```javascript
 * import '@cof/fs-container-wc/fs-container.js';
 * ```
 *
 * To import the `FsContainer` class as either a base class or to self-register the custom element, use
 *
 * ```javascript
 * import { FsContainer } from '@cof/fs-container-wc';
 * ```
 *
 * ## Anatomy
 * ### DOM Structure
 * ```html
 * <fs-container>
 *
 * </fs-container>
 * ```
 *
 * @element fs-container
 * @slot - The default slot allows for any content to be slotted inside the container.
 */
export class FsContainer extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Whether or not the container has an optional border.
         */
        this.border = false;
        /**
         * The optional elevation applied to the container.
         * Can be one of 1, 2, or 3.
         * If a border is applied, elevation will be ignored.
         */
        this.elevation = null;
        /**
         * The optional radius applied to the container.
         * Can be one of 'tiny', 'small', 'medium', 'large', or 'x-large'.
         */
        this.radius = null;
    }
    static get styles() {
        return containerHostStyles;
    }
    /**
     * Render the component.
     *
     * @returns TemplateResult
     */
    render() {
        return html `<slot></slot>`;
    }
}
/** The element's canonical name for use with safe define */
FsContainer.canonicalName = 'container';
__decorate([
    property({ type: Boolean, reflect: true })
], FsContainer.prototype, "border", void 0);
__decorate([
    property({ type: Number, reflect: true })
], FsContainer.prototype, "elevation", void 0);
__decorate([
    property({ type: String, reflect: true })
], FsContainer.prototype, "radius", void 0);
//# sourceMappingURL=Container.js.map